<template>
  <li @click="showDetail()">
    <div class="order-info">
      <ul class="list">
        <li class="item">
          <strong> 매입일자 : </strong>
          <span> {{ props.item.prsdt }} </span>
        </li>
      </ul>
      <div class="store-code">
        <span>{{ props.item.zdeptName }}</span>
        <span>제품코드 {{ props.item.matnr }}</span>
      </div>
    </div>
    <div class="info-detail">
      <div class="product-info">
        <p>
          {{ props.item.zzmaktx }} {{ Number(props.item.kwmeng) }}*{{
            props.item.zztotalQty
          }}
        </p>
      </div>
      <div class="price-info">
        <div class="price-info-item">
          <strong>매입금액</strong>
          <span>{{ Number(props.item.netwr).toLocaleString() }}원</span>
        </div>
      </div>
    </div>
  </li>
</template>
<script setup>
import { defineProps, defineEmits } from "vue";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
});

const emit = defineEmits(["detail"]);

function showDetail() {
  emit("detail", props.item);
}
</script>
